// Material-ui datetime picker
import MomentUtils from "@date-io/moment";
import { Tooltip } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import DateRangeIcon from "@material-ui/icons/DateRange";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import "moment/locale/en-ca";
import "moment/locale/vi";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { styles } from "./styles";
class PickerDateRange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      from: this.props.from || "",
      to: this.props.to || "",
      statusFilter: this.props.from || this.props.to ? true : false,
    };
  }
  handleChangeDate = (name, date) => {
    let { from, to } = this.state;
    if (name === "from" && moment(date).isAfter(to)) {
      this.setState(
        {
          from: date,
          to: date,
        },
        function () {
          this.props.handleFilterDate(this.state.from, this.state.to);
        }
      );
    } else if (name === "to" && moment(date).isBefore(from)) {
      this.setState(
        {
          from: date,
          to: date,
        },
        function () {
          this.props.handleFilterDate(this.state.from, this.state.to);
        }
      );
    } else {
      this.setState({ [name]: date }, function () {
        this.props.handleFilterDate(this.state.from, this.state.to);
      });
    }
  };
  changeStatus = () => {
    if (this.state.statusFilter === true)
      this.props.handleFilterDate(null, null);
    else this.props.handleFilterDate(this.state.from, this.state.to);
    this.setState({
      statusFilter: !this.state.statusFilter,
    });
  };
  render() {
    const { classes, t, i18n, alignItems, titleToolip } = this.props;
    let { from, to, statusFilter } = this.state;
    moment.locale(i18n.language === "vn" ? "vi" : "en");
    let activeColor = "#536E7A";
    let nonActiveColor = "#C5C5C5";
    return (
      <React.Fragment>
        <MuiPickersUtilsProvider
          libInstance={moment}
          utils={MomentUtils}
          locale={i18n.language === "vn" ? "vi" : "en"}
        >
          <Grid
            container
            spacing={1}
            direction="column"
            alignItems={alignItems || "center"}
          >
            <Grid item>
              <ButtonGroup
                variant="text"
                size="small"
                aria-label="small contained button group"
                classes={{
                  root: classes.btnGroupContainer,
                }}
              >
                {titleToolip ? (
                  <Tooltip title={titleToolip}>
                    <Button
                      classes={{
                        root: classes.btnRoot,
                      }}
                      onClick={() => this.changeStatus()}
                    >
                      <DateRangeIcon
                        style={{
                          color: statusFilter ? activeColor : nonActiveColor,
                        }}
                      />
                    </Button>
                  </Tooltip>
                ) : (
                  <Button
                    classes={{
                      root: classes.btnRoot,
                    }}
                    onClick={() => this.changeStatus()}
                  >
                    <DateRangeIcon
                      style={{
                        color: statusFilter ? activeColor : nonActiveColor,
                      }}
                    />
                  </Button>
                )}
                <DatePicker
                  className={statusFilter ? "" : classes.nonActiveDatePicker}
                  TextFieldComponent={(props) => {
                    return (
                      <Button
                        classes={{
                          root: classes.btnRoot,
                        }}
                        {...props}
                      >
                        {props.value}
                      </Button>
                    );
                  }}
                  format="DD/MM/YYYY"
                  value={from}
                  onChange={(date) => this.handleChangeDate("from", date)}
                  cancelLabel={t("date_picker_cancel")}
                  okLabel={t("date_picker_ok")}
                />
                <DatePicker
                  className={statusFilter ? "" : classes.nonActiveDatePicker}
                  TextFieldComponent={(props) => {
                    return (
                      <Button
                        classes={{
                          root: classes.btnRoot,
                        }}
                        {...props}
                      >
                        {props.value}
                      </Button>
                    );
                  }}
                  format="DD/MM/YYYY"
                  value={to}
                  onChange={(date) => this.handleChangeDate("to", date)}
                  cancelLabel={t("date_picker_cancel")}
                  okLabel={t("date_picker_ok")}
                />
              </ButtonGroup>
            </Grid>
          </Grid>
        </MuiPickersUtilsProvider>
      </React.Fragment>
    );
  }
}

PickerDateRange.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
PickerDateRange.defaultProps = {};
const mapState = (state) => ({
  bookingState: state.booking,
});

const mapDispatch = (dispatch) => ({
  bookingDispatch: dispatch.booking,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(PickerDateRange)
  )
);
